// Anello sottile "orbita" per l'andamento annuale delle timbrature.
// Corrette = arco colorato (colore dipende dalla percentuale). Irregolari = arco neutro grigio-azzurro.
export function colorFor(pct) {
  if (pct > 90) return "#16A34A";        // verde
  if (pct >= 80) return "#CA8A04";       // giallo
  if (pct >= 75) return "#EA580C";       // arancione
  return "#DC2626";                       // rosso
}

const fmt1 = (n) => n.toLocaleString("it-IT", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export function OrbitChart({ year, correct = 0, irregular = 0, percentCorrect = 100 }) {
  const total = correct + irregular;
  const pct = total ? percentCorrect : 100;
  const irregularPct = total ? Math.round((irregular / total) * 1000) / 10 : 0;
  const accent = colorFor(pct);

  const size = 132, stroke = 10, r = (size - stroke) / 2;
  const C = 2 * Math.PI * r;
  const correctLen = (pct / 100) * C;

  return (
    <div data-testid="orbit-chart" className="rounded-2xl bg-white border border-slate-200 shadow-sm p-5">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-3">Andamento timbrature · {year}</p>
      <div className="flex items-center gap-5">
        <div className="relative shrink-0" style={{ width: size, height: size }}>
          <svg width={size} height={size} className="-rotate-90">
            <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
            {/* arco irregolari (neutro grigio-azzurro) sotto */}
            <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#CBD5E1" strokeWidth={stroke}
              strokeDasharray={`${C} ${C}`} strokeDashoffset={0} strokeLinecap="round" />
            {/* arco corrette (colorato) sopra */}
            <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={accent} strokeWidth={stroke}
              strokeDasharray={`${correctLen} ${C}`} strokeDashoffset={0} strokeLinecap="round"
              style={{ transition: "stroke-dasharray 0.6s ease, stroke 0.4s ease" }} />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span data-testid="orbit-percent" className="font-heading text-2xl font-bold leading-none" style={{ color: accent }}>{fmt1(pct)}%</span>
            <span className="text-[11px] text-slate-500 mt-0.5">corrette</span>
          </div>
        </div>
        <div className="min-w-0">
          <p className="text-sm text-slate-600">Regolarità delle timbrature dell'anno.</p>
          <p className="text-xs text-slate-500 mt-2" data-testid="orbit-legend">
            <span style={{ color: accent }} className="font-semibold">Corrette {fmt1(pct)}%</span>
            <span className="text-slate-400"> · </span>
            <span className="text-slate-500 font-semibold">Irregolari {fmt1(irregularPct)}%</span>
          </p>
          {total > 0 && <p className="text-[11px] text-slate-400 mt-1">{correct} corrette · {irregular} irregolari su {total} timbrature</p>}
        </div>
      </div>
    </div>
  );
}
